import { SALESMAN_MASTER_KEYWORD_FILTER } from "constants/ActionTypes";

const initialState = {
    keywordFilter: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SALESMAN_MASTER_KEYWORD_FILTER:
            return {
                ...state,
                keywordFilter: action.payload,
            };
        default:
            return state;
    }
};
